var AccessPolicy;
(function (AccessPolicy) {
    AccessPolicy[AccessPolicy["ViewKpmgAdmins"] = 1] = "ViewKpmgAdmins";
    AccessPolicy[AccessPolicy["ViewClientAdmins"] = 2] = "ViewClientAdmins";
    AccessPolicy[AccessPolicy["ViewCompanies"] = 3] = "ViewCompanies";
    AccessPolicy[AccessPolicy["ViewUsers"] = 4] = "ViewUsers";
    AccessPolicy[AccessPolicy["AddCompany"] = 5] = "AddCompany";
    AccessPolicy[AccessPolicy["AddUser"] = 6] = "AddUser";
    AccessPolicy[AccessPolicy["EditCompany"] = 7] = "EditCompany";
    AccessPolicy[AccessPolicy["EditClient"] = 8] = "EditClient";
    AccessPolicy[AccessPolicy["ViewCalculations"] = 9] = "ViewCalculations";
    AccessPolicy[AccessPolicy["AddCalculation"] = 10] = "AddCalculation";
    AccessPolicy[AccessPolicy["EditUser"] = 11] = "EditUser";
    AccessPolicy[AccessPolicy["ViewDocuments"] = 12] = "ViewDocuments";
    AccessPolicy[AccessPolicy["AddDocuments"] = 13] = "AddDocuments";
    AccessPolicy[AccessPolicy["EditHistoricalModule"] = 14] = "EditHistoricalModule";
    AccessPolicy[AccessPolicy["AddComments"] = 15] = "AddComments";
    AccessPolicy[AccessPolicy["EditCalculation"] = 16] = "EditCalculation";
    AccessPolicy[AccessPolicy["ViewCompany"] = 17] = "ViewCompany";
    AccessPolicy[AccessPolicy["ViewUser"] = 18] = "ViewUser";
    AccessPolicy[AccessPolicy["ViewCalculation"] = 19] = "ViewCalculation";
    AccessPolicy[AccessPolicy["DeleteDocument"] = 20] = "DeleteDocument";
    AccessPolicy[AccessPolicy["DeleteCompany"] = 21] = "DeleteCompany";
    AccessPolicy[AccessPolicy["ViewHistoricalModule"] = 23] = "ViewHistoricalModule";
    AccessPolicy[AccessPolicy["ViewNotifications"] = 24] = "ViewNotifications";
})(AccessPolicy || (AccessPolicy = {}));
export default AccessPolicy;
